import { render, staticRenderFns } from "./InfocardsListViewControls.vue?vue&type=template&id=83885a04&scoped=true&"
import script from "./InfocardsListViewControls.vue?vue&type=script&lang=js&"
export * from "./InfocardsListViewControls.vue?vue&type=script&lang=js&"
import style0 from "./InfocardsListViewControls.vue?vue&type=style&index=0&id=83885a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83885a04",
  null
  
)

export default component.exports